export const CENTERS_FILTERS = [
  {
    value: 'pcr',
    indexValue: '214143',
    label: 'Tests RT-PCR',
  },
  {
    value: 'ta',
    indexValue: '214145',
    label: 'Tests antigéniques',
    isChecked: true,

  },
  {
    value: 'ts',
    indexValue: '214481',
    label: 'Tests salivaires',
  },
];

export const CENTERS_TYPES = [
  {
    value: 'prioAvail',
    label: 'créneaux personnes prioritaires',
    apiValue: ['Prélèvement Covid-19 - Créneaux pour personnes prioritaires', 'Prélèvement Covid-19'],
    apiKey: 'prioAvail(213781)',
  },
  {
    value: 'prioAll',
    label: 'ouverts à tout public',
    apiValue: ['Prélèvement Covid-19'],
    apiKey: 'prioAll (213415)',
  },
  {
    value: 'prioOnly',
    label: 'uniquement personnes prioritaires',
    apiValue: ['Prélèvement Covid-19 - Personnes prioritaires uniquement'],
    apiKey: 'prioOnly(213783)',
  },
];
